/* eslint-disable radix */
export const getCountryFilterById = (languageFilters, countryId) =>
  languageFilters &&
  languageFilters.filter((c) => c.countryId === countryId)[0];

export const getCountriesFilter = (languageFilters, lang = 1) => {
  const countries = [];

  if (languageFilters) {
    const filters = languageFilters.filter(
      (item) => item.languageId === 0 || item.languageId === parseInt(lang, 0)
    );

    filters.map((filter) => {
      countries.push({
        id: filter.countryId,
        name: filter.country,
        slugName: filter.slugName,
      });
    });
  }

  return countries;
};

export const getCountriesAnyPlaceFilter = (languageFilters, lang = 1) => {
  const countries = [];

  if (languageFilters) {
    const filters = languageFilters.filter(
      (item) => item.languageId === parseInt(lang, 0)
    );

    filters.map((filter) => {
      countries.push({
        id: filter.countryId,
        name: filter.country,
        slugName: filter.slugName,
      });
    });
  }

  addAnyCountry(countries);

  return countries;
};

export const addAnyCountry = (countries) => {
  countries.unshift({ id: 0, name: 'Qualquer lugar', slugName: '' });

  return countries;
};

export const getCountryByName = (countries, countryName) => {
  const country = countries.find((item) => item.name === countryName);

  return country;
};

export const selectedCountryName = (_params, _countries) => {
  if (!_countries) return '';

  if (_params.countryId) {
    const country = _countries.find((c) => c.id === _params.countryId);

    return country?.slugName;
  }

  return '';
};

export const getRandomCountryURL = () => {
  const countries = [
    'south-africa',
    'australia',
    'canada',
    'united-states',
    'england',
    'malta',
    'new-zealand',
    'ireland',
  ];

  const randomIndex = Math.floor(Math.random() * countries.length);
  const dynamicCountry = countries[randomIndex];

  const url = `OnlineSchool/MyAccount/AbroadCountries/${dynamicCountry}`;

  return url;
};
